import { SubscriptionEntitlements } from "src/app/subscription/subscriptionUtils";
import { SubscriptionUsageModalMode } from "src/app/subscription/modals/SubscriptionUsageModal/SubscriptionUsageModal";
import { API_URLS } from "src/utils/API_URLS";
import { subscriptionTypes } from "./subscriptionTypes";

export function setSubscriptionUsageModalMode(
  subscriptionUsageModalMode: SubscriptionUsageModalMode | null,
) {
  return {
    type: subscriptionTypes.SET_SUBSCRIPTION_MODAL_MODE,
    payload: { subscriptionUsageModalMode },
  };
}

export function setManageSubscriptionModalVisibility(
  manageSubscriptionModalVisible: boolean,
) {
  return {
    type: subscriptionTypes.SET_MANAGE_SUBSCRIPTION_MODAL_VISIBILITY,
    payload: { manageSubscriptionModalVisible },
  };
}

export function setPlanUpgradeNeededModalContext(
  planUpgradeNeededModalContext: SubscriptionEntitlements | null,
) {
  return {
    type: subscriptionTypes.SET_PLAN_UPGRADE_NEEDED_MODAL_CONTEXT,
    payload: { planUpgradeNeededModalContext },
  };
}

export function setSubscriptionContactModalDisplayMode(
  subscriptionContactModalDisplayMode: null | "default" | "demandPermission",
) {
  return {
    type: subscriptionTypes.SET_SUBSCRIPTION_CONTACT_MODAL_DISPLAY_MODE,
    payload: { subscriptionContactModalDisplayMode },
  };
}

export function setUnlockAddonsModalVisibility(
  unlockAddonsModalVisibility: boolean,
) {
  return {
    type: subscriptionTypes.SET_UNLOCK_ADDONS_MODAL_VISIBILITY,
    payload: { unlockAddonsModalVisibility },
  };
}

export function setAddBillingInfoModalVisibility(
  addBillingInfoModalVisibility: boolean,
) {
  return {
    type: subscriptionTypes.SET_ADD_BILLING_INFO_MODAL_VISIBILITY,
    payload: { addBillingInfoModalVisibility },
  };
}

export function getSubscriptionBillingInfo(workspaceUuid: string) {
  const url = API_URLS.getSubscriptionBillingInfo.replace(
    ":workspaceUuid:",
    workspaceUuid,
  );

  return {
    type: subscriptionTypes.GET_SUBSCRIPTION_BILLING_INFO,
    payload: {
      request: { url },
    },
  };
}

export function getSubscriptionPlan(workspaceUuid: string) {
  const url = API_URLS.getSubscriptionPlan.replace(
    ":workspaceUuid:",
    workspaceUuid,
  );

  return {
    type: subscriptionTypes.GET_SUBSCRIPTION_PLAN,
    payload: {
      request: { url },
    },
  };
}

export function getSubscriptionEntitlement(
  workspaceUuid: string,
  feature: SubscriptionEntitlements,
) {
  const url = API_URLS.getSubscriptionEntitlement
    .replace(":workspaceUuid:", workspaceUuid)
    .replace(":feature:", feature);

  return {
    type: subscriptionTypes.GET_SUBSCRIPTION_ENTITLEMENT,
    payload: {
      request: {
        url,
      },
      feature,
    },
  };
}
